import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Loader from "./loader";

const AppLoader = ({ children }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const { service } = useParams();
  const waitForAssets = async () => {
    const images = Array.from(document.images);
    const videos = Array.from(document.querySelectorAll("video"));
    const elements = Array.from(document.querySelectorAll("*"));

    const imagePromises = images.map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete && img.naturalHeight !== 0) resolve();
          else {
            img.onload = resolve;
            img.onerror = resolve;
          }
        })
    );

    const videoPromises = videos.map(
      (video) =>
        new Promise((resolve) => {
          if (video.readyState >= 3) resolve();
          else {
            video.onloadeddata = resolve;
            video.onerror = resolve;
          }
        })
    );

    const backgroundPromises = elements.map((el) => {
      const style = getComputedStyle(el);
      const match = style.backgroundImage.match(/url\(["']?(.*?)["']?\)/);
      const bgUrl = match?.[1];
      if (!bgUrl) return Promise.resolve();

      return new Promise((resolve) => {
        const img = new Image();
        img.src = bgUrl;
        if (img.complete) resolve();
        else {
          img.onload = resolve;
          img.onerror = resolve;
        }
      });
    });

    return Promise.all([
      ...imagePromises,
      ...videoPromises,
      ...backgroundPromises,
    ]);
  };

  useEffect(() => {
    let isMounted = true;

    const handleLoad = async () => {
      // First check if everything is already cached
      const allImages = Array.from(document.images);
      const allCached = allImages.every(
        (img) => img.complete && img.naturalHeight !== 0
      );

      if (allCached) {
        // Skip loader entirely
        setIsLoading(false);
        return;
      }

      // Otherwise, show loader and wait for assets
      setIsLoading(true);
      await new Promise((res) => requestAnimationFrame(res)); // wait for render
      await waitForAssets();
      if (isMounted)
        setTimeout(() => {
          setIsLoading(false);
        }, 300);
    };

    handleLoad();

    return () => {
      isMounted = false;
    };
  }, [location.pathname, service]);

  return (
    <>
      {isLoading && (
        <div className="w-[100vw] h-[100vh] flex items-center justify-center fixed top-0 left-0 bg-white z-50">
          <Loader />
        </div>
      )}
      <div style={{ visibility: isLoading ? "hidden" : "visible" }}>
        {children}
      </div>
    </>
  );
};

export default AppLoader;
